export * from './list.component';
export * from './list-item.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/list/index.ts